import { flexRender, Cell } from "@tanstack/react-table";
import { cn } from "@/lib/utils";

interface TableCellProps<TData> {
  cell: Cell<TData, unknown>;
  className?: string;
}

export function TableCell<TData>({ cell, className = "" }: TableCellProps<TData>) {
  const meta = cell.column.columnDef.meta as { className?: string; stickyLeft?: number } | undefined;
  
  return (
    <td
      className={cn(
        "px-4 py-3",
        // Pinned column: opaque, and it follows the row's hover / open-menu highlight
        meta?.stickyLeft !== undefined &&
          "sticky z-10 bg-background group-hover:bg-muted group-data-[menu-open=true]:bg-muted",
        meta?.className,
        className
      )}
      style={meta?.stickyLeft !== undefined ? { left: meta.stickyLeft } : undefined}
    >
      {flexRender(cell.column.columnDef.cell, cell.getContext())}
    </td>
  );
}
